<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="xrefViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'XRef',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        { text: 'HITS', align: 'start', sortable: true, value: 'total_views' }
      ],
      xrefViews: [],
      month: ''
    }
  },
  mounted() {
    this.getXRefViews()
  },
  methods: {
    getXRefViews() {
      this.loading = true
      axios
        .get(
          `api/get-tag-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.xrefViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=xref&name=XREF HITS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getXRefViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
